module.exports = __webpack_public_path__ + "img/activate-logo-mono-darkbg-1@2x.8dda26a9.png";